import React, { useEffect } from 'react'

function INSPACTLOCK() {
    useEffect(() => {
        const isAdmin = typeof window !== 'undefined' && window.location.search.includes('?admin=cw')

        if (isAdmin) return // ✅ Skip lock for admin URLs

        const handleKeyDown = (e) => {
            if (
                e.key === 'F12' ||
                (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key)) ||
                (e.ctrlKey && e.key === 'U')
            ) {
                e.preventDefault()
            }
        }

        const handleRightClick = (e) => {
            e.preventDefault()
        }

        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('contextmenu', handleRightClick)

        // Load disable-devtool script from CDN — PRODUCTION ONLY.
        // In development it fights the developer's open DevTools and, when it detects them,
        // can wipe/navigate the document — detaching React's DOM and causing
        // "Failed to execute 'removeChild'" crashes across the whole panel.
        if (process.env.NODE_ENV === 'production' && typeof window.__ddid === 'undefined') {
            window.__ddid = setTimeout(() => {
                const script = document.createElement('script')
                script.src = 'https://cdn.jsdelivr.net/npm/disable-devtool'
                script.setAttribute('disable-devtool-auto', '')
                script.setAttribute('disable-menu', 'false')
                document.head.appendChild(script)
            }, 100)
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.removeEventListener('contextmenu', handleRightClick)
        }
    }, [])

    return <></>
}

export default INSPACTLOCK
